import { render, staticRenderFns } from "./SignInCover.vue?vue&type=template&id=fbfa3fd0&scoped=true&"
import script from "./SignInCover.vue?vue&type=script&lang=js&"
export * from "./SignInCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfa3fd0",
  null
  
)

export default component.exports